import { style } from 'typestyle'

export const chapterListDiv = style({
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1rem',
})
